export const workTypeName = Object.freeze({
  Publication: 'publication',
  Monography: 'monography',
  PrePrint: 'prePrint',
  Dissertation: 'dissertation',
  Grant: 'grant',
  Contest: 'contest',
  Performance: 'performance',
  Incalculation: 'incalculation',
  StudentGuide: 'studentGuide',
  EducationalPublication: 'educationalPublication',
  NirAccomplishment: 'nirAccomplishment',
  PublicOrganizationParticipation: 'publicOrganizationParticipation',
  OverseasEvent: 'overseasEvent',
  StateAward: 'stateAward',
  CooperationInformation: 'cooperationInformation',
  WinningScientificCompetition: 'winningScientificCompetition',
  NirCompensationAgreement: 'nirCompensationAgreement',
  ScientificPracticalEvent: 'scientificPracticalEvent',
  JournalEditorialBoard: 'journalEditorialBoard'
})

export const getWorkTypeNameById = id => {
  switch (id) {
    case 1:
      return workTypeName.Publication
    case 2:
      return workTypeName.Monography
    case 3:
      return workTypeName.PrePrint
    case 4:
      return workTypeName.Dissertation
    case 5:
      return workTypeName.Grant
    case 6:
      return workTypeName.Contest
    case 7:
      return workTypeName.Performance
    case 8:
      return workTypeName.Incalculation
    case 9:
      return workTypeName.StudentGuide
    case 10:
      return workTypeName.EducationalPublication
    case 11:
      return workTypeName.NirAccomplishment
    case 12:
      return workTypeName.PublicOrganizationParticipation
    case 13:
      return workTypeName.OverseasEvent
    case 14:
      return workTypeName.StateAward
    case 15:
      return workTypeName.CooperationInformation
    case 16:
      return workTypeName.WinningScientificCompetition
    case 17:
      return workTypeName.NirCompensationAgreement
    case 18:
      return workTypeName.ScientificPracticalEvent
    case 19:
      return workTypeName.JournalEditorialBoard
    default:
      return undefined
  }
}

export const getWorkTypeIdByName = name => {
  switch (name) {
    case workTypeName.Publication:
      return 1
    case workTypeName.Monography:
      return 2
    case workTypeName.PrePrint:
      return 3
    case workTypeName.Dissertation:
      return 4
    case workTypeName.Grant:
      return 5
    case workTypeName.Contest:
      return 6
    case workTypeName.Performance:
      return 7
    case workTypeName.Incalculation:
      return 8
    case workTypeName.StudentGuide:
      return 9
    case workTypeName.EducationalPublication:
      return 10
    case workTypeName.NirAccomplishment:
      return 11
    case workTypeName.PublicOrganizationParticipation:
      return 12
    case workTypeName.OverseasEvent:
      return 13
    case workTypeName.StateAward:
      return 14
    case workTypeName.CooperationInformation:
      return 15
    case workTypeName.WinningScientificCompetition:
      return 16
    case workTypeName.NirCompensationAgreement:
      return 17
    case workTypeName.ScientificPracticalEvent:
      return 18
    case workTypeName.JournalEditorialBoard:
      return 19
    default:
      return undefined
  }
}

export const workStatusListName = Object.freeze({
  Draft: 'draft',
  Review: 'review',
  Accepted: 'accepted',
  Revision: 'revision',
  Rejected: 'rejected',
  Actualization: 'actualization'
})

export const workStatusList = Object.freeze({
  1: workStatusListName.Draft,
  2: workStatusListName.Review,
  3: workStatusListName.Accepted,
  4: workStatusListName.Revision,
  5: workStatusListName.Rejected,
  6: workStatusListName.Actualization
})

export const workStatusId = Object.freeze({
  [workStatusListName.Draft]: 1,
  [workStatusListName.Review]: 2,
  [workStatusListName.Accepted]: 3,
  [workStatusListName.Revision]: 4,
  [workStatusListName.Rejected]: 5,
  [workStatusListName.Actualization]: 6
})

export const fileTypeId = Object.freeze({
  link: 1,
  agreement: 2
})

export const Roles = Object.freeze({
  Admin: 'ROLE_ADMIN',
  Moderator: 'ROLE_MODERATOR',
  ModeratorNir: 'ROLE_MODERATOR_NIR',
  ModeratorDiss: 'ROLE_MODERATOR_DISS',
  ModeratorGrantContest: 'ROLE_MODERATOR_GRANT_CONTEST',
  ModeratorScientificEvent: 'ROLE_MODERATOR_SCIENTIFIC_EVENT',
  Employee: 'ROLE_EMPLOYEE',
  ViewEfficiencyMetrics: 'ROLE_VIEW_EFFICIENCY_METRICS',
  ViewScientificWork: 'ROLE_VIEW_SCIENTIFIC_WORK',
  DepartManager: 'ROLE_DEPART_MANAGER',
  Auditor: 'ROLE_AUDITOR'
})

export const workMode = Object.freeze({
  Edit: 'edit',
  Show: 'show',
  Process: 'process'
})

export const dictionaryNames = Object.freeze({
  NirType: 'nirType',
  Year: 'year',
  Speciality: 'speciality',
  Department: 'department',
  FundingRecipient: 'fundingRecipient',
  Bibliography: 'bibliography',
  ParticipationStatus: 'participationStatus',
  ParticipationKind: 'participationKind',
  GuideType: 'guideType',
  PublicationForm: 'publicationForm',
  PublishingHouse: 'publishingHouse',
  State: 'state',
  InteractionType: 'interactionType',
  CouncilName: 'councilName',
  AcademicDegree: 'academicDegree',
  Period: 'period',
  InculcationLevel: 'inculcationLevel',
  DissertationDegree: 'dissertationDegree',
  Status: 'status',
  ScientDepartment: 'scientDepartment',
  NirLevel: 'nirLevel',
  ContestResult: 'contestResult',
  CooperationType: 'cooperationType',
  Organization: 'organization',
  ForeignOrganization: 'foreignOrganization',
  Country: 'country',
  ScientistName: 'scientistName',
  ProtectionPlace: 'protectionPlace',
  ScienceStep: 'scienceStep',
  Highschool: 'highschool',
  EducationalPublicationType: 'educationalPublicationType',
  Contest: 'contest',
  PerformanceType: 'performanceType',
  EventType: 'eventType',
  EventFormat: 'eventFormat',
  ParticipantQuantity: 'participantQuantity',
  Catalog: 'catalog',
  WhiteListLevel: 'whiteListLevel',
  Position: 'position',
  EmployeePosition: 'employeePosition',
  Employee: 'employee',
  Duty: 'duty',
  PersonTitle: 'personTitle',
  SalaryRate: 'salaryRate',
  Activity: 'activity',
  Filetype: 'filetype',
  Reward: 'reward',
  Quarter: 'quarter',
  Boolean: 'boolean',
  EditorialBoardRole: 'editorialBoardRole'
})
